(async () => {
  if (!customElements.get('shop-drawer')) {
    class VariantStoreAvailability extends HTMLElement {
      constructor() {
        super();

        this.token = this.dataset.token;
        this.handle = this.dataset.handle;
        if (!this.token || !this.handle) {
          return;
        }

        // Query selectors
        this.locations = this.querySelector('shop-locations');
        this.variantsWrapper = this.querySelector('variants-product fieldset');
        this.storesWrapper = this.querySelector('shop-locations');
        if (!this.variantsWrapper || !this.locations || !this.storesWrapper) {
          return;
        }
        this.variantInputs = this.variantsWrapper.querySelectorAll('input');
        this.stores = this.storesWrapper.querySelectorAll('[data-location]');
        if (!this.variantInputs || !this.stores) {
          return;
        }

        // Event listeners
        this.variantInputs.forEach((variant) => {
          variant.addEventListener('click', () => {
            const currentVariant = variant.value;
            this.updateLocations(currentVariant);
          });
        });
      }

      /**
       * Get the variants data from the product
       * @returns { object } The variant location data
       */
      async getLocationsData() {
        // Check if we already have the data
        if (this.locationsData) {
          return this.locationsData;
        }

        // Return if we don't have the token or handle
        if (!this.token || !this.handle) {
          return false;
        }

        // Create the query
        const PRODUCT_QUERY =
          `
          query {
            product(handle: "` +
          this.handle +
          `") {
              title
              totalInventory
              variants(first: 10) {
                nodes {
                  title
                  availableForSale
                  quantityAvailable
                  storeAvailability(first: 10) {
                    nodes {
                      available
                      location {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        `;

        // Create the fetch request url
        const GRAPHQL_URL = `https://` + location.host + `/api/2023-04/graphql.json`;

        // Create the fetch request body
        const GRAPHQL_BODY = {
          async: true,
          crossDomain: true,
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': this.token,
            'Content-Type': 'application/graphql',
          },
          body: PRODUCT_QUERY,
        };

        // Fetch the data
        const response = await fetch(GRAPHQL_URL, GRAPHQL_BODY);
        const data = await response.json();

        // Save the data in the component
        this.locationsData = data.data.product.variants.nodes;

        // Return the data
        return this.locationsData;
      }

      /**
       *
       * @param {string} currentVariant
       */
      async updateLocations(currentVariant) {
        if (!currentVariant) {
          return;
        }

        // Uncheck all variants inputs except the current one
        this.variantInputs.forEach((variant) => {
          if (variant.value != currentVariant) {
            variant.checked = false;
          } else {
            variant.checked = true;
          }
        });

        // Get the locations data
        const locationsData = await this.getLocationsData();
        if (!locationsData) {
          console.log('there is no location data');
          return;
        }

        // Get the active variant
        const locationData = locationsData.filter((variant) => {
          return variant.title == currentVariant;
        });

        // Get the stores data
        const storesData =
          locationData && locationData[0] ? locationData[0].storeAvailability.nodes : [];
        const availableForSale =
          locationData && locationData[0] ? locationData[0].availableForSale : false;

        // Loop over the store elements
        this.stores.forEach((store) => {
          // Get the store id from the element
          const storeId = store.dataset.location;

          // Get the store data from the stores data
          const storeData = storesData.filter((store) => {
            const id = store.location.id.split('/').reverse()[0];
            return id == storeId;
          });

          // Set the store to available or unavailable
          if (!availableForSale) {
            this.setStoreUnavailable(store);
          } else if (!storeData || !storeData[0]) {
            this.setStoreUnavailable(store);
          } else if (storeData[0].available) {
            this.setStoreAvailable(store);
          } else {
            this.setStoreUnavailable(store);
          }
        });
      }

      /**
       * Set the store to available
       * @param { object } store The store element
       */
      setStoreAvailable(store) {
        if (!store) {
          return;
        }
        store.querySelector('[data-location-button]').classList.remove('disabled');
        store.querySelector('.icon--checkmark').classList.remove('hidden');
        store.querySelector('.icon--cross').classList.add('hidden');
        store.querySelector('[data-button-available-text]').classList.remove('hidden');
        store.querySelector('[data-button-unavailable-text]').classList.add('hidden');
        store.querySelector('[data-available-txt]').classList.remove('hidden');
        store.querySelector('[data-unavailable-txt]').classList.add('hidden');
      }

      /**
       * Set the store to unavailable
       * @param { object } store The store element
       */
      setStoreUnavailable(store) {
        if (!store) {
          return;
        }
        store.querySelector('[data-location-button]').classList.add('disabled');
        store.querySelector('.icon--checkmark').classList.add('hidden');
        store.querySelector('.icon--cross').classList.remove('hidden');
        store.querySelector('[data-button-available-text]').classList.add('hidden');
        store.querySelector('[data-button-unavailable-text]').classList.remove('hidden');
        store.querySelector('[data-available-txt]').classList.add('hidden');
        store.querySelector('[data-unavailable-txt]').classList.remove('hidden');
      }
    }
    customElements.define('shop-drawer', VariantStoreAvailability);
  }
})();
